
import { MessageCircle } from "lucide-react";

interface OffersPlaceholderProps {
  isLoading: boolean;
  isEmpty: boolean;
  statusFilter: string;
}

export const OffersPlaceholder = ({ isLoading, isEmpty, statusFilter }: OffersPlaceholderProps) => {
  if (isLoading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading offers...</p>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-100">
        <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <MessageCircle className="h-8 w-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No offers found</h3>
        <p className="text-gray-500">
          {statusFilter === "all" 
            ? "You haven't made any offers yet."
            : `No ${statusFilter.toLowerCase()} offers found.`}
        </p>
      </div>
    );
  }

  return null;
};
